import React, { useEffect } from "react";
import Header from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import BottomFooter from "../components/BottomFooter";
import MyAccount from "../components/myAccount/MyAccount";

const MyAccountPage = () => {
  useEffect(() => {
    document.documentElement.classList.add("my-account-html");
    document.body.classList.add("my-account-body");

    return () => {
      document.documentElement.classList.remove("my-account-html");
      document.body.classList.remove("my-account-body");
    };
  }, []);

  return (
    <div className="my-account-route bg-white">
      <Header category={true} />
      {/* Breadcrumb */}
      <Breadcrumb title={"My Account"} />
      <MyAccount />
      <BottomFooter />
    </div>
  );
};

export default MyAccountPage;
